// extracted by mini-css-extract-plugin
module.exports = {"root":"FormPage_root__tDgPU","content":"FormPage_content__1dkWj","title":"FormPage_title__8L1uJ","description":"FormPage_description__cckB7"};